module.exports = __webpack_public_path__ + "img/dark-grey.105a0efd.webp";